//import SmoothScroll from "smoothscroll-for-websites";
// new SmoothScroll({ stepSize: 60 });
import AOS from 'aos';

AOS.init({
    once: true,
    offset: 150,
    duration: 700,
    delay: 100
});

// Header scroll
const header = document.querySelector('.page-header');
const headerHeight = header.getBoundingClientRect().height;

document.addEventListener('scroll', () => {
    if (window.pageYOffset > 0) {
        header.classList.add('scrolled');
    } else {
        header.classList.remove('scrolled');
    }
});

// How it works Steps
const stepLineNumbs = document.querySelectorAll('.how-to-line__item-num-box-icons-wrap');
const stepLineInnerItems = document.querySelectorAll('.how-to-line__item-inner');

if (window.innerWidth >= 768) {
    stepLineNumbs.forEach((item) => {
        item.addEventListener('click', function H() {
            stepLineInnerItems.forEach((item) => {
                item.classList.remove('active');
            });

            this.parentNode.parentNode.classList.add('active');
        });
    });
}

// gradient border on focused form elements
const groupInputs = document.querySelectorAll('.input-group input');
const groupTextArea = document.querySelectorAll('.input-group textarea');

function focusGradient(input) {
    input.forEach(e => {
        e.addEventListener('focus', function H() {
            this.parentNode.classList.add('focus')
        });
        e.addEventListener('blur', function H() {
            this.parentNode.classList.remove('focus');
        });
    });
}

focusGradient(groupInputs);
focusGradient(groupTextArea);

// form nice select
$(document).ready(function() {
    $('select').niceSelect();
});

//switch form tabs clicked book demo button
const bookDemoBtn = document.querySelectorAll('.book-js');
const contactBtn = document.querySelectorAll('.contact-js');
const formTabs1 = document.querySelectorAll('.tab-1');
const formTabs2 = document.querySelectorAll('.tab-2');

//scroll to function
function scrollTo(dataScrollSection, header, ms) {
    setTimeout(() => {
        $('html, body').animate({ scrollTop: $(`[data-scroll='${dataScrollSection}']`).offset().top - header }, 1000, () => {
            const x = window.scrollX;
            const y = window.scrollY;

            window.scrollTo(x, y);
        });
    }, ms);
}

bookDemoBtn.forEach(e => {
    e.addEventListener('click', () => {
        sessionStorage.setItem('bm', 'true');
    });
});

contactBtn.forEach(e => {
    e.addEventListener('click', () => {
        sessionStorage.setItem('contact-scroll', 'true');
    });
});

// load form tabs depend on button click
window.addEventListener('load', () => {
    // Contact form scroll
    if (sessionStorage.getItem('bm')) {
        if (document.querySelector('.page-contact')) {
            sessionStorage.removeItem('bm');

            scrollTo('get-in', headerHeight, 500);

            setTimeout(()=> {
                formTabs2.forEach(e => { e.classList.add('isActive'); });
                formTabs1.forEach(e => { e.classList.remove('isActive'); });
            }, 500);
        }
    } else if (sessionStorage.getItem('contact-scroll')) {
        if (document.querySelector('.page-contact')) {
            sessionStorage.removeItem('contact-scroll');

            scrollTo('get-in', headerHeight, 500);
        }
    }
});

// burger menu toggle
if (document.querySelector('.burger-wrapper')) {
    document.querySelector('.burger-wrapper').addEventListener('click', function H() {
        let __this = this;

        __this.classList.toggle('open');
        document.querySelector('.page-header__inner-container').classList.toggle('open');
        header.classList.toggle('open');
        document.querySelector('.page-body').classList.toggle('show');
    });
}

// toggle team bio on cards
const teamListItems = document.querySelectorAll('.team-list__item');

if (window.innerWidth <= 1024) {
    teamListItems.forEach(item => {
        item.addEventListener('click', e => {
            e.currentTarget.classList.toggle('flip');
        });
    });
}
